import { useEphattaMutation } from '../../..';
import { useCustomerFavoriteService } from './useCustomerFavoriteService';

export const useCustomerFavoriteDelete = () => {
    const service = useCustomerFavoriteService()
    return useEphattaMutation(
        (id: number) => service.delete(id)
    )
} 